import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ICommentModel } from '@fi-app/shared/models';
import { FiCommentsListHelperService } from '../../services/fi-comments-list-helper.service';
import { ObjectTypes } from '@fi-app/shared/types';

@Component({
    selector: 'fi-comment-footer',
    templateUrl: './fi-comment-footer.component.html',
    styleUrls: ['./fi-comment-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-comment-footer' },
    standalone: false,
})
export class FiCommentFooterComponent {
    @Input({ required: true }) comment: ICommentModel;
    @Input({ required: true }) isDisabled: boolean;
    @Input({ required: true }) showEditor: boolean;
    @Output() onReplyToggle = new EventEmitter<void>();

    protected readonly ObjectTypes = ObjectTypes;

    constructor(private commentsListHelperService: FiCommentsListHelperService) {}

    protected toggleReply(): void {
        this.onReplyToggle.emit();
    }

    protected getTotalChildrenCount(): number {
        return this.commentsListHelperService.getTotalChildrenCount(this.comment);
    }
}
